export const FEATURES_CONSTANTS = {
  title: "Key Benefits of Private Kubernetes Clusters",
  list: [
    {
      label: "Network Isolation",
      text: "Ensures that nodes and pods communicate over internal networks, enhancing security.",
    },
    {
      label: "Restricted API Access",
      text: "Limits API server accessibility to within the private network, often secured via VPNs or bastion hosts.",
    },
    {
      label: "Enhanced Security",
      text: "Reduces exposure to external threats by isolating cluster components from the public internet.",
    },
    {
      label: "Compliance Alignment",
      text: "Meets stringent security and compliance requirements by controlling access and data flow within the cluster.",
    },
    {
      label: "Customizable Networking",
      text: "Allows for tailored network configurations to meet specific organizational policies and performance needs.",
    },
    {
      label: "Integrated Monitoring and Logging",
      text: "Facilitates comprehensive tracking of cluster activities to ensure operational integrity and security.",
    },
  ],
};
